export default __webpack_public_path__ + "static/media/banner-1-4.628c45b8.png";